export default {
    appConfig: {
        baseApiUrl: '/api/v1/',
        productCategory: '692a1a31-1a46-4ac9-bf36-142aa242f1d5',
        coinCategory: '30f115f7-7851-4b49-95f2-a969b2167a47',
        merchCategory: 'e875ac70-2bc9-41fc-996e-836579e59dc1',
        seminarCategory: 'ed48d95e-a8f8-43db-9cc1-66ed6432b9b6',
    }
}
